/**
 * Premium decoration batch definitions: a glowing lantern, a rock grotto and
 * a playful treasure chest. Each keeps only subtle ambient motion.
 */

export type PremiumDecorId = 'lantern' | 'grotto' | 'treasure';

export interface PremiumDecorPalette {
  base: string;
  baseLight: string;
  baseDark: string;
  accent: string;
  glow: string;
  shimmer: string;
  detail: string;
}

export interface PremiumDecorMotion {
  glow: number;
  float: number;
  shimmer: number;
  delay: number;
}

export interface PremiumDecorDef {
  id: PremiumDecorId;
  label: string;
  palette: PremiumDecorPalette;
  motion: PremiumDecorMotion;
}

export const PREMIUM_DECOR: Record<PremiumDecorId, PremiumDecorDef> = {
  lantern: {
    id: 'lantern',
    label: 'Glow Lantern',
    palette: {
      base: '#3a4a4a',
      baseLight: '#5a6a6a',
      baseDark: '#1a2a2a',
      accent: '#ffd77d',
      glow: '#fff0bd',
      shimmer: '#ffe9a8',
      detail: '#c8a05a',
    },
    motion: { glow: 2.8, float: 5.4, shimmer: 3.6, delay: 0 },
  },
  grotto: {
    id: 'grotto',
    label: 'Rock Grotto',
    palette: {
      base: '#4a5a6a',
      baseLight: '#6a7d8d',
      baseDark: '#2c3a48',
      accent: '#8fd6b4',
      glow: '#bfe8d4',
      shimmer: '#d8f0e2',
      detail: '#3a5a4a',
    },
    motion: { glow: 4.2, float: 6.6, shimmer: 4.4, delay: 0.3 },
  },
  treasure: {
    id: 'treasure',
    label: 'Treasure Chest',
    palette: {
      base: '#8a5a34',
      baseLight: '#b07a48',
      baseDark: '#5c3a20',
      accent: '#ffd166',
      glow: '#ffe9a8',
      shimmer: '#fff2c0',
      detail: '#e0a83c',
    },
    motion: { glow: 3.4, float: 5.8, shimmer: 2.8, delay: 0.15 },
  },
};

export const PREMIUM_DECOR_ORDER: PremiumDecorId[] = ['lantern', 'grotto', 'treasure'];
